import type { ReactNode } from 'react';
import type { ThemeTypes } from '../../../types/Theme.namespace';

const POSITION = {
  ABOVE: 'ABOVE',
  BELOW: 'BELOW',
} as const;

const VARIANT = {
  DARK: 'DARK',
  LIGHT: 'LIGHT',
} as const;

type Positions = (typeof POSITION)[keyof typeof POSITION];
type Variants = (typeof VARIANT)[keyof typeof VARIANT];

type TooltipProps = {
  isOpen: boolean;
  children: ReactNode;
  headerText?: string;
  headerFontSize?: ThemeTypes.FontSize;
  headerFontWeight?: ThemeTypes.FontWeight;
  copy?: string;
  askToClose?: () => void;
  position?: Positions;
  variant?: Variants;
  className?: string;
  dataTrackingAttribute?: string;
};

export { POSITION, VARIANT };
export type { TooltipProps, Positions, Variants };
